module.exports = __webpack_public_path__ + "static/media/household-big.8686fba5.png";